import {useMutation} from '@tanstack/react-query';
import ChessRestClient from '../../Api/ChessRestClient';

export default function useDeleteStudy(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (data: any) => void,
) {
  return useMutation<any, Error, string>(
    async (studyGameSlug: string) => {
      const response = await ChessRestClient.delete(
        `/learning/study_games/${studyGameSlug}/delete/`
      );
      return response.data;
    },
    {
      onSuccess: data => {
        if (handleOnSuccess) handleOnSuccess(data);
      },
      onError: error => {
        if (handleOnError) handleOnError(error);
      },
    },
  );
}
